// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"9f395754","419":"03449f07","715":"5df37da4","774":"532cc8c4","787":"1342cae8","858":"9eb73784","878":"d6322ca2","883":"36e93805"}[chunkId] + ".chunk.js";
};